import React from 'react';
import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs';
import { AlignJustify, LayoutGrid } from 'lucide-react';
import { cn } from 'lib/utils';
import { useIsMediaLibrary } from 'hooks/use-is-media-library';

interface ViewToggleProps {
  viewMode: string;
  onViewModeChange: (mode: string) => void;
  className?: string;
}

const viewToggleTriggerClassName =
  'h-7 w-10 rounded-md border-0 bg-transparent px-0 text-muted-foreground shadow-none transition-all hover:bg-transparent hover:text-foreground dark:text-[#ffffff] data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm';

const libraryToggleButtonClassName =
  'flex size-8 items-center justify-center rounded-[6px] text-[#3d3d3d] transition-colors hover:bg-[#f6f6f6] dark:text-foreground dark:hover:bg-muted data-[state=active]:bg-[#f6f6f6] data-[state=active]:text-[#3d3d3d] dark:data-[state=active]:bg-muted dark:data-[state=active]:text-foreground';

export const ViewToggle: React.FC<ViewToggleProps> = ({
  viewMode,
  onViewModeChange,
  className = '',
}) => {
  const isMediaLibrary = useIsMediaLibrary();

  if (isMediaLibrary) {
    return (
      <Tabs value={viewMode} onValueChange={onViewModeChange}>
        <TabsList
          className={cn(
            'h-8 gap-1 overflow-visible border-0 bg-transparent p-0 shadow-none',
            className
          )}
        >
          <TabsTrigger
            value="grid"
            className={cn(
              libraryToggleButtonClassName,
              'bg-transparent px-0 py-0 shadow-none data-[state=active]:bg-[#f6f6f6] data-[state=active]:shadow-none'
            )}
          >
            <LayoutGrid className="size-[21px]" strokeWidth={1.75} />
          </TabsTrigger>
          <TabsTrigger
            value="list"
            className={cn(
              libraryToggleButtonClassName,
              'bg-transparent px-0 py-0 shadow-none data-[state=active]:bg-[#f6f6f6] data-[state=active]:shadow-none'
            )}
          >
            <AlignJustify className="size-[21px]" strokeWidth={1.75} />
          </TabsTrigger>
        </TabsList>
      </Tabs>
    );
  }

  return (
    <Tabs value={viewMode} onValueChange={onViewModeChange}>
      <TabsList
        className={cn(
          'h-8 gap-0.5 rounded-lg border border-[#e7e7e7] bg-muted p-0.5 shadow-sm dark:border-grey-400',
          className
        )}
      >
        <TabsTrigger value="list" className={viewToggleTriggerClassName}>
          <AlignJustify className="h-4 w-4" />
        </TabsTrigger>
        <TabsTrigger value="grid" className={viewToggleTriggerClassName}>
          <LayoutGrid className="h-4 w-4" />
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};
